// extracted by mini-css-extract-plugin
module.exports = {"TCSectionC":"TCSectionC_TCSectionC__eZVjJ"};